import React from 'react';
import ComissionChain from './comission-chain';

function App() {
  const crud = {
    exportGrid: {
      show: true, // ou false dependendo da lógica
      permissionId: '', // ou string vazia, null, etc
    },
  };

  return <ComissionChain crud={crud} />;
}

export default App; 